export enum EBookingStatus {
    CREATED,
    PROCESSING,
    CONFIRMED,
    REJECTED,
}